export interface Biometric {
  id: string;
  name: string;
  shortName: string | null;
  unit: string | null;
  nlk: string | null;
  furstId: string | null;
  furstName: string | null;
  furstSortIndex: string | null;
  about: string | null;
  howToIncrease: string | null;
  howToDecrease: string | null;
  premiumOnly: boolean;
  createdAt: string;
  updatedAt: string;
}

export type ReferenceType = "optimal_min" | "optimal_max" | "normal_min" | "normal_max";

export interface ReferenceRange {
  id: string;
  biometricId: string;
  gender: string | null;
  minAge: string;
  maxAge: string;
  referenceType: ReferenceType;
  value: string;
  createdAt: string;
  updatedAt: string;
}

export interface BiometricPrice {
  id: string;
  biometricId: string;
  price: number; // stored in ore (1 NOK = 100 ore)
  source: string;
}

export interface Category {
  id: string;
  name: string;
  description: string;
  color: string;
  biometricIds: string[];
  createdAt: string;
  updatedAt: string;
}

export interface BloodTestPackage {
  id: string;
  name: string;
  description: string;
  priceInNok: number;
  biometricIds: string[];
  createdAt: string;
  updatedAt: string;
}

export interface Lab {
  id: string;
  name: string;
  address: string;
  city: string;
  openingHours: string;
  manualBookingText: string;
  snailMailRequisition: boolean;
  createdAt: string;
  updatedAt: string;
}

export type QuestionKind = "onboarding" | "followup" | "healthdata";
export type AdvancedQuestionType = "double_question" | "multiple_select" | "single_select" | "multiple_free_text";

export interface QuestionCategory {
  id: string;
  name: string;
  description: string;
  introHeader: string;
  order: number;
  createdAt: string;
  updatedAt: string;
}

export interface QuestionAlternative {
  id: string;
  questionId: string;
  text: string;
  order: number;
  isOther: boolean;
  biometricIds: string[];
}

export interface Question {
  id: string;
  categoryId: string;
  question: string;
  description: string;
  nickname: string;
  kind: QuestionKind;
  tags: string;
  advancedQuestionType: AdvancedQuestionType | null;
  secondaryQuestion: string | null;
  sequenceNumber: number;
  isNumber: boolean;
  multipleSelect: boolean;
  multipleSelectMaxOptions: number | null;
  createdAt: string;
  updatedAt: string;
}

export const REFERENCE_TYPE_LABELS: Record<ReferenceType, string> = {
  normal_max: "Standard Hoy",
  normal_min: "Standard Lav",
  optimal_max: "Optimal Hoy",
  optimal_min: "Optimal Lav",
};

export const GENDER_LABELS: Record<string, string> = {
  male: "Mann",
  female: "Kvinne",
};

export const QUESTION_KIND_LABELS: Record<QuestionKind, string> = {
  onboarding: "Onboarding",
  followup: "Oppfolging",
  healthdata: "Helsedata",
};

export const ADVANCED_TYPE_LABELS: Record<AdvancedQuestionType, string> = {
  double_question: "Dobbeltsporsmal",
  multiple_select: "Flervalg",
  single_select: "Enkeltvalg",
  multiple_free_text: "Flere fritekst",
};
